/*
 * @Author: huangyf huangyf@efly.cc
 * @Date: 2022-01-19 18:00:27
 * @LastEditors: huangyf huangyf@efly.cc
 * @LastEditTime: 2024-08-09 15:20:39
 * @FilePath: \agent\manage\main\src\components\login-header\login-header.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import {Component, Prop, Vue, Emit} from 'vue-property-decorator';
import common from '../../../../common/src/assets/js/common';
import Service from '../../../../common/src/assets/service/service';
import environment from '../../../../common/src/assets/environment/environment';
declare var $: any;

@Component
export default class LoginHeader extends Vue {
    public $store: any;
    public $router: any;
    private companyLogo: string = '';
    private siteLogo: string = '';
    private siteName: string = '';
    private status: any = {
        logo: 'loading'
    }

    private skiphome() {
        // window.location.href = 'http://' + window.location.host + "/oam/#/";
        
        window.location.href = '/';
        
    }
    mounted() {
        this.getSystemInfo()
    }
    /**获取系统首页信息 且添加css文件*/
    getSystemInfo() {
        let params = {
            userID: common.getUserID(),
        };
        this.status.logo = 'loading';
        let url = environment.apiPrefix + '/common/GetStaticPic?path=';
        Service.request('/user/agentConfig/getSystemInfo', params, 'token').then((res:any) => {
            if (res.ret === 2) {
                this.companyLogo = res.data.companyLogo ? url + this.tidyUrl(res.data.companyLogo) : (res.data.siteLogo ? url + this.tidyUrl(res.data.siteLogo) : '');
                this.siteLogo = res.data.siteLogo ? url + this.tidyUrl(res.data.siteLogo) : '';
                this.siteName = res.data.siteName ? res.data.siteName : '';
                sessionStorage.setItem('front_systemInfo', JSON.stringify(res.data))
                this.$store.commit('setSystemInfo', res.data||{});
                this.status.logo = this.companyLogo ? 'havedata' : 'nodata';
                this.change_icon();
            }
        }).catch((error:any) => {
            this.status.logo = 'nodata';
        })
    }
    private tidyUrl(url:any) {
        let imgitem = url;
        let imgUrl = imgitem && imgitem.split('/');
        if (imgUrl && imgUrl[1] !== 'upload') {
            // imgUrl = imgUrl.splice(2, imgUrl.length).join('/');
            imgUrl = '/upload' + url;
        } else {
            imgUrl = url;
        }
        return imgUrl;
    }
    /**动态修改站点图标 和 站点名称*/
    change_icon() {
        const changeFavicon = (link:any) => {
            let $favicon: any = document.querySelector('link[rel="icon"]');
            console.log('link[rel="icon', $favicon);
            if ($favicon !== null) {
                $favicon.href = link;
            } else {
                $favicon = document.createElement("link");
                $favicon.rel = "icon";
                $favicon.href = link;
                document.head.appendChild($favicon);
            }
        };
        // 设置站点名称
        let $siteTitle = document.getElementById('siteName');
        $siteTitle!.innerHTML = this.siteName;
        // 设置图标地址
        let iconUrl = this.siteLogo;
        // 动态修改网站图标
        changeFavicon(iconUrl);
    }
}
